import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  card: {
    position: 'relative',
    padding: 8,
  },
  fullScreenCard: {
    padding: 8,
    zIndex: 1,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: 0,
  },
  title: {
    borderRadius: '4px 4px 0 0',
    background: 'silver',
    fontWeight: 600,
    padding: '0.25rem 0.5rem',
    marginBottom: '0.5rem',
    margin: -8,
  },
  fullScreenTitle: {
    background: 'silver',
    fontWeight: 600,
    padding: '1rem 0.75rem 0.5rem 1rem',
    marginBottom: '1rem',
    margin: -8,
  },
})
